import React, {
    useRef,
    memo,
    HTMLProps,
    useEffect,
    MutableRefObject,
} from 'react';
import cn from 'classnames';
import { PLACE_HOLDER } from 'src/constants';
import Image from '..';
import { useImage } from 'src/hooks';

interface IProps extends HTMLProps<HTMLImageElement> {
    className?: string;
    src: string;
    alt?: string;
    title?: string;
    size?: number;
    rounded?: boolean;
    domRef?: any;
    renderAs?: string;
}

export function LazyloadImage({
    src,
    size = 48,
    alt,
    className,
    domRef,
    ...rest
}: IProps) {
    const imgRef: MutableRefObject<HTMLImageElement | null> =
        useRef<HTMLImageElement>(null);
    const [imgSrc] = useImage({ src, imgRef, intersectionObserverOptions: {
        rootMargin: '400px'
    } });

    const onLoad = () => {
        if (imgSrc !== PLACE_HOLDER.IMAGE) {
            if (imgRef.current) {
                imgRef.current.classList.add(
                    '!opacity-100',
                    'transition-opacity',
                    'duration-200'
                );
            }
        }
    };

    return (
        <Image
            {...rest}
            ref={imgRef}
            src={imgSrc}
            size={size}
            alt={alt}
            onLoad={onLoad}
            className={cn('lazy-image', className, {
                'opacity-0': imgSrc,
            })}
        />
    );
}

export default memo(LazyloadImage);
